import React from 'react';
import '../LegalPages.css';

const TermosDeUso = () => {
  return (
    <div className="legal-page-container">
      <h1>Termos de Uso</h1>
      <p><strong>Última atualização:</strong> 21 de Agosto de 2025</p>

      <h2>1. Objeto</h2>
      <p>Estes Termos de Uso regem o acesso e a utilização do website do <strong>Hotel Alzira Plaza</strong>, localizado em [www.hotelalziraPlaza.com.br], incluindo todos os seus serviços, em especial o sistema de consulta de disponibilidade e realização de reservas online.</p>

      <h2>2. Aceitação</h2>
      <p>Ao acessar e utilizar nosso website, você concorda integralmente com os termos e condições descritos neste documento e com a nossa <a href="/politica-de-privacidade">Política de Privacidade</a>. Caso não concorde com algum dos termos, solicitamos que não utilize nossos serviços.</p>

      <h2>3. Acesso e Utilização</h2>
      <p>O usuário se compromete a utilizar o website de forma ética, legal e em conformidade com a moral e os bons costumes. A realização de reservas e transações financeiras é restrita a maiores de 18 (dezoito) anos com capacidade civil para tal.</p>

      <h2>4. Reservas e Pagamentos</h2>
      <p>4.1. As reservas realizadas através do nosso site estão sujeitas à disponibilidade de acomodações e à confirmação do pagamento.</p>
      <p>4.2. Os preços informados podem sofrer alterações sem aviso prévio. O valor final da reserva será o vigente no momento da confirmação do pagamento.</p>
      <p>4.3. O pagamento será processado por meio de plataformas de terceiros (gateway de pagamento). O <strong>Hotel Alzira Plaza</strong> não se responsabiliza por falhas na segurança ou na operação dessas plataformas.</p>
      <p>4.4. A confirmação da reserva será enviada para o e-mail cadastrado pelo usuário após a aprovação da transação financeira.</p>

      <h2>5. Política de Cancelamento e Reagendamento</h2>
      <p>As regras, prazos e eventuais taxas para o cancelamento ou reagendamento de reservas estão detalhadas em nossa **Política de Reservas**, apresentada durante o processo de compra. O usuário declara ter lido e concordado com tais regras ao finalizar uma reserva.</p>
      
      <h2>6. Propriedade Intelectual</h2>
      <p>Todo o conteúdo deste website, incluindo, mas não se limitando a, textos, imagens, logos, marcas e design, é de propriedade exclusiva do <strong>Hotel Alzira Plaza</strong>, protegido pela legislação brasileira de propriedade intelectual. É proibida a sua reprodução, distribuição ou utilização para fins comerciais sem autorização prévia e expressa.</p>

      <h2>7. Limitação de Responsabilidade</h2>
      <p>O <strong>Hotel Alzira Plaza</strong> não se responsabiliza por interrupções no acesso ao website, por danos causados por vírus ou por falhas de sistema. O usuário é o único responsável por manter seu equipamento seguro.</p>
      
      <h2>8. Legislação Aplicável</h2>
      <p>Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da Comarca de São Lourenço, Minas Gerais, para dirimir quaisquer controvérsias oriundas deste documento.</p>

      <h2>9. Contato</h2>
      <p>Em caso de dúvidas sobre estes termos, entre em contato conosco pelo e-mail: <strong>[contato@alziraPlaza.com]</strong>.</p>
    </div>
  );
};

export default TermosDeUso;